import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import './RepaymentRemarksModal.css'

const RepaymentRemarksModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted, status,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  remarks, onRemarksChange, remarksError, setRemarksError,
  tdsAmount, onTdsAmountChange, tdsAmountError, setTdsAmountError,
  dsraDipInterestWaived, onRemarksBoolChange, booleanSelectList,
  leviedAmount, onLeviedAmountChange, leviedAmountError, setLeviedAmountError,
  waivedAmount, onWaivedAmountChange, waivedAmountError, setWaivedAmountError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add remarks'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='g_flex_h g_flex_top c_rep_upd'>
      <div>
        {
          status === 'unpaid' &&
          <>
            <InputSelectSF type='select' name='dsraDipInterestWaived' label='DSRA dip interest waived'
              value={dsraDipInterestWaived} onChange={onRemarksBoolChange} optionList={booleanSelectList}
              error={remarksError}
            />
            {/*
            <InputTextSF type='text' name='levied' maxLength={12}
              label='Levied amount (₹)'
              value={leviedAmount} onChange={onLeviedAmountChange}
              error={leviedAmountError} setError={setLeviedAmountError}
            />
            */}
            {/*
            <InputTextSF type='text' name='waived' maxLength={12}
              label='Waived amount (₹)'
              value={waivedAmount} onChange={onWaivedAmountChange}
              error={waivedAmountError} setError={setWaivedAmountError}
            />
            */}
          </>
        }
        <InputTextAreaSF type='text' name='remarks' label='Internal remarks'
          value={remarks} onChange={onRemarksChange}
          error={remarksError} setError={setRemarksError}
          help='500 characters max'
        />
        <InputTextSF type='text' name='tdsAmount' label='TDS amount'
          value={tdsAmount} onChange={onTdsAmountChange}
          error={tdsAmountError} setError={setTdsAmountError}
        />
      </div>
    </div>
  </ModalFormUI>

export default RepaymentRemarksModalUI
